// extracted by mini-css-extract-plugin
export var content = "Negotiation-module--content--c22c5";
export var core = "Negotiation-module--core--54f20";
export var cta = "Negotiation-module--cta--75062";
export var image = "Negotiation-module--image--6444a";